export const FEATURE_FLAGS = {
  NOTICE_REVIEW_INCLUDE_VEHICLE_MAKE: "notice_review_include_vehicle_make",
  NOTICE_REVIEW_REQUIRE_CONFIRM_ADVISE_DRIVER: "notice_review_require_confirm_advise_driver",
  NOTICE_REVIEW_OPERATOR_ASSIGNMENT_IS_ENABLED: "notice_review_operator_assignment_is_enabled",
  INVOICE_REVIEW_IS_ENABLED: "invoice_review_is_enabled",
  PENDING_NOTICES_DWELL_COLUMN: "pending_notices_dwell_column",
  PENDING_NOTICES_TOW_ELIGIBLE_COLUMN: "pending_notices_tow_eligible_column",
  MANUAL_CITATIONS_IS_ENABLED: "manual_citations_is_enabled",
  DISPLAY_SERVICE_FEE_COLUMN: "display_service_fee_column",
} as const;
